import type { RoleCode } from './types';

function normalize(s: string): string {
  return s.replace(/\s+/g, ' ').trim().toLowerCase();
}

/**
 * Role mapping based on the provided PDF.
 * Backend active-user payload currently provides role *name* (defaultRole) reliably;
 * roleCode may be null/absent, so we normalize from the role name.
 */
export function roleNameToRoleCode(roleName: string): RoleCode {
  const r = normalize(roleName);
  if (!r) return 'UNKNOWN';

  if (r.includes('allocation')) return 'ALLOCATION_OFFICER';
  if (r.includes('supervis')) return 'SUPERVISING_OFFICER';
  if (
    r.includes('management assistant') ||
    r.includes('management_assistant') ||
    r.includes('office clerk')
  ) {
    return 'OFFICE_CLERK';
  }
  if (r.includes('mail')) return 'MAIL_OPERATIONS_OFFICER';
  if (r.includes('record')) return 'RECORD_MANAGEMENT_OFFICER';
  if (r.includes('legal repository')) return 'LEGAL_REPOSITORY_OFFICER';
  if (r.includes('attorney general')) return 'ATTORNEY_GENERAL';
  if (r.includes('solicitor general')) return 'SOLICITOR_GENERAL';
  if (r.includes('state attorney')) return 'STATE_ATTORNEY';
  if (r.includes('junior') && (r.includes('counsel') || r.includes('councel'))) return 'JUNIOR_COUNSEL';
  if (r.includes('counsel') || r.includes('councel')) return 'COUNSEL';
  if (r.includes('assigned') || r.includes('attorney') || r.includes('solicitor')) {
    return 'ASSIGNED_OFFICER';
  }

  return 'UNKNOWN';
}

/** True when the active role is Junior Counsel (subsidiary-task assignee, not case workflow owner). */
export function isJuniorCounselRole(roleName: string): boolean {
  const r = normalize(roleName);
  return r.includes('junior') && (r.includes('counsel') || r.includes('councel'));
}

